import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import { setupLocale } from '../locale/i18n.js';
import WhitelabelContext from './WhitelabelContext.jsx';

export default function mountWhitelabelApp(store, localeOptions, whitelabelContext, Component, targetElement) {
    function setUpdateHandler(handleStateChange) {
        store.subscribe(handleStateChange);

        handleStateChange();
    }

    setupLocale(localeOptions);

    setUpdateHandler(() => {
        ReactDOM.render(
            <Provider store={store}>
                <WhitelabelContext.Provider value={whitelabelContext}>
                    <Component />
                </WhitelabelContext.Provider>
            </Provider>,
            document.getElementById(targetElement)
        );
    });
}
